var exports = {
  "CB": "RoleManagement.module__roleIndicator___T3lkem",
  "KG": "RoleManagement.module__roleBadge___T3lkem",
  "Gy": "RoleManagement.module__roleRemoveButtonContainer___T3lkem",
  "j1": "RoleManagement.module__roleRemoveButton___T3lkem",
  "r4": "RoleManagement.module__roleRemoveIconContainer___T3lkem",
  "S3": "RoleManagement.module__roleName___T3lkem",
  "MR": "RoleManagement.module__roleListContainer___T3lkem",
  "ek": "RoleManagement.module__assignRoleButton___T3lkem",
  "JO": "RoleManagement.module__assignRoleButtonIcon___T3lkem",
  "RK": "RoleManagement.module__iconSize___T3lkem",
  "Xk": "RoleManagement.module__noRolesLink___T3lkem",
  "X9": "RoleManagement.module__roleColorIndicator___T3lkem",
};

module.exports = exports;
